<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-3 mb-2">
          <router-link to="/" class="footer-link">
            <h2 class="footer-title">skinlove.ge</h2>
          </router-link>
          <p class="footer-text">
            უმაღლესი ხარისხის ორიგინალი კოსმეტიკა, სახისა და ტანის მოვლის საშუალებები. ყველაზე საინტერესო და სანდო ბრენდები მთელი მსოფლიოდან.
          </p>
        </div>
        <div class="col-12 col-md-3 mb-2">
          <h2 class="footer-title">მისამართი</h2>
          <a
            href="https://www.google.com/maps/place/12+%E1%83%9B%E1%83%A8%E1%83%95%E1%83%98%E1%83%93%E1%83%9D%E1%83%91%E1%83%98%E1%83%A1+%E1%83%92%E1%83%90%E1%83%9B%E1%83%96%E1%83%98%E1%83%A0%E1%83%98,+Gori/@41.9851106,44.098976,17z/data=!3m1!4b1!4m5!3m4!1s0x40449ea2eda2d23d:0xce6ad0997159f237!8m2!3d41.9851106!4d44.1011647"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-text"
          >მშვიდობის გამზირი 12, გორი</a>
        </div>
        <div class="col-12 col-md-3 mb-2">
          <h2 class="footer-title">კონტაქტი</h2>
          <p class="footer-text">
            ტელ:
            <a class="footer-text" href="Tel:+995598997797">+995 598 99 77 97</a>
          </p>
          <p class="footer-text">
            ელ. ფოსტა:
            <a
              class="footer-text"
              href="Mailto:skinlove.ge@gmail.com"
            >skinlove.ge@gmail.com</a>
          </p>
        </div>
        <div class="col-12 col-md-3 mb-2">
          <h2 class="footer-title">სოციალური მედია</h2>
            <a href="https://www.facebook.com/Skinlove.ge" target="_blank" rel="noopener noreferrer" class="footer-text d-block">
              <span class="fa fa-facebook-square"></span> facebook
            </a>
          <a href="https://www.instagram.com/skinlove.ge" target="_blank" rel="noopener noreferrer" class="footer-text d-block">
              <span class="fa fa-instagram"></span> instagram
            </a>
        </div>
        <div class="col-12 mt-2 text-center">
          <router-link to="/" class="footer-link">
            <span class="footer-text">&copy; 2020 skinlove.ge</span>
          </router-link>
          <a href="https://www.linkedin.com/in/megi-akhalkatsi-72851b186/" target="_blank" rel="noopener noreferrer" class="footer-text d-block">Designed And Developed By Megi Akhalkatsi</a>
        </div>
      </div>
    </div>
  </footer>
</template> 

<script>
export default {
  name: "appFooter"
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global";
.footer {
  border-top: 2px solid $skyblueLight;
  padding: 5vh 0;
  &-title {
    color: $skyblueLight;
    font-size: $font-md;
    font-family: $fontALKSanet;
    font-weight: bold;
  }
  &-text {
    color: $skyblueLight;
    font-size: $font-sm;
    font-family: $fontALKSanet;
    text-decoration: none;
    margin-bottom: auto;
  }
  &-link {
    &:hover {
      text-decoration: none;
    }
  }
}
</style>